'use client';

import { DataTable } from 'shared/ui/data-table';
import { columns } from 'widgets/env-var-data-table/ui/columns';
import { getAllVariables } from '@/enteties/env-variables/api';
import { envVarKeys } from '@/enteties/env-variables/api/env-var.query-keys';
import { useQueryWithOnError } from 'shared/hooks/query/useQueryWithOnError';
import { LoadingDataTable } from 'shared/ui/loading/loading-data-table';
import * as m from '@paraglide/messages';
export const EnvVarsDataTable = ({
  slug,
  withPagination = true
}: {
  slug: string;
  withPagination?: boolean;
}) => {
  const projectEnvVars = useQueryWithOnError({
    queryKey: envVarKeys.projectEnvVars(slug),
    queryFn: () => getAllVariables(slug),
    refetchOnMount: false,
    retry: false
  });
  if (projectEnvVars.isLoading) return <LoadingDataTable columns={4} />;
  if (!projectEnvVars.isSuccess || !projectEnvVars.data.length) {
    return <div className="flex size-full flex-1 justify-center">
        <h3 className="text-2xl font-bold tracking-tight text-center">
          {m.tab_envvars_noVars()}
        </h3>
      </div>;
  }
  return <DataTable rowsPerPage={[10, 20, 30, 40, 50]} columns={columns(slug)} data={projectEnvVars.data} withPagination={withPagination} data-sentry-element="DataTable" data-sentry-component="EnvVarsDataTable" data-sentry-source-file="env-vars-data-table.tsx" />;
};